import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const PaymentSuccess: React.FC = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const tokenParam = searchParams.get('orderId'); // 'orderId' is your token
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState<boolean>(false);
    const [debugInfo, setDebugInfo] = useState<string>('Starting payment processing...');

    useEffect(() => {
        const capturePayment = async () => {
            setDebugInfo('Checking token parameter...');
            if (!tokenParam) {
                const msg = 'Missing payment token in URL.';
                setDebugInfo(msg);
                setError(msg);
                return;
            }

            setDebugInfo('Checking auth token...');
            const authToken = localStorage.getItem('authToken');
            if (!authToken) {
                const msg = 'Authentication token not found. Please log in again.';
                setDebugInfo(msg);
                setError(msg);
                navigate('/login');
                return;
            }

            setDebugInfo(`Calling capture-order API with token: ${tokenParam}`);
            try {
                const response = await axios.get(
                    `https://nrimarriage.in:/api/v1/paypal/capture-order?token=${tokenParam}`,
                    {
                        headers: {
                            Authorization: `Bearer ${authToken}`,
                            'Content-Type': 'application/json',
                        },
                    }
                );

                console.log('✅ Payment captured:', response.data);
                setSuccess(true);
                setDebugInfo('Payment captured successfully.');

                setTimeout(() => {
                    navigate('/home'); // Redirect to any page
                }, 2500);
            } catch (err: any) {
                console.error('❌ Capture failed:', err);
                setDebugInfo(`Capture failed: ${err.message || err.toString()}`);
                setError('Payment confirmation failed. Please contact support.');
            }
        };

        capturePayment();
    }, [tokenParam, navigate]);

    return (
        <div style={{
            textAlign: 'center',
            marginTop: '50px',
            padding: '20px',
            fontFamily: 'Arial, sans-serif',
            backgroundColor: '#f7f7f7',
            borderRadius: '10px',
            maxWidth: '600px',
            marginLeft: 'auto',
            marginRight: 'auto',
            boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        }}>
            {error ? (
                <div>
                    <h2 style={{ color: 'red' }}>❌ {error}</h2>
                </div>
            ) : success ? (
                <div>
                    <h2 style={{ color: 'green' }}>✅ Payment Successful!</h2>
                    <p>Redirecting to your dashboard...</p>
                </div>
            ) : (
                <div>
                    <h2>Processing Payment...</h2>
                    <p style={{ marginTop: '20px', fontSize: '14px', color: '#888' }}>
                        <strong>Debug info:</strong> {debugInfo}
                    </p>
                </div>
            )}
        </div>
    );
};

export default PaymentSuccess;
